module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust6-1200x2490.8cca6c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust6-1200x2490.jpg
// module id = 1012
// module chunks = 37